
import { installPassport, isInHospEnv, isProd } from '../services/base';
import { defineComponent, onMounted, reactive } from 'vue';
import { getLoginPageConfig, isShowLinkdocText } from '../services/serviceA';
import { LoginBox } from '@linkdoc/uc-loginbox';
import PrivateLogin from './PrivateLogin.vue';
import { isNuwarwe } from '@/utils/project';
import { isNuc } from '@/utils/env';

export default defineComponent({
  components: {
    LoginBox,
    PrivateLogin
  },
  setup() {
    interface LoginState {
      title: string;
      core: string;
      desc: string;
      logo: string;
      isHenanBc: boolean;
      isInHospEnv: boolean;
    }
    const showLinkdocText = isShowLinkdocText();
    const state = reactive<LoginState>({
      // 不建议在此给初始值，会呈现内容变动情况
      title: '',
      core: '',
      desc: '',
      logo: '',
      isHenanBc: false,
      isInHospEnv: !!isInHospEnv,
    });

    onMounted(() => {
      getLoginPageConfig().then(res => {
        // console.log('获取登录页配置', res);
        if (res.success) {
          if (location.host.indexOf('nuwarwe.net') > -1) {
            // 女娲平台
            state.title = '中国妇瘤大数据平台（NUWA平台）';
            state.core = '提供切实可行的疾病机制研究方向和研究路线的中国第一个妇科肿瘤多组学大数据平台';
            state.desc = '中国妇瘤大数据平台联合30+家研究中心，收集整合妇科肿瘤患者的临床诊疗信息、基因检测信息、生物样本库信息、影像信息和患者随访信息，预期建立中国人卵巢癌BRCA基因突变检测库、卵巢癌NGS大PANEL数据库、卵巢癌生物样本库等数据库，开展全国多中心研究并发表多篇高质量SCI论文。';
            state.logo = res.data.logo;
          } else if (location.host.indexOf('henanbc') > -1) {
            state.logo = res.data.logo;
            state.isHenanBc = true;
          } else {
            const data = res.data;
            state.title = data.platformTitle || '智能医学科研云平台';
            state.core = data.platformCore || '提供符合医生习惯的医学科研数据采集、管理、及应用的一站式服务。';
            state.desc = data.platformDesc || '零氪科技，成立于2014年，作为一家数据驱动、AI赋能的医疗科技公司，秉承“Care Data Care Life”的初心和使命，为患者和产业各方（制药企业、医疗机构、保险机构、行政监管部门）提供大数据一站式解决方案，打造“让医生易诊易疗易科研、让患者有好医好药好服务”的互联网医疗平台。';
            state.logo = data.logo;
          }
          if (isInHospEnv) {
            console.log('私有化部署');
            // 私有化部署
          } else {
            // 云端部署 注册登录窗
            console.log('云端部署');
            if (isProd()) {
              installPassport();
            }
          }
        }
      });
    });

    return {
      showLinkdocText,
      state,
      isNuwarwe,
      isNuc,
    };
  }
});
